import React, { useState } from "react";
import {TextField} from "@mui/material";
import {produce} from "immer";
import MenuItem from "@mui/material/MenuItem";

const ValidatedTextField = ({
                                id,
                                label,
                                validator,
                                onChange,
                                setActiveForm,
                                isSubmitting,
                                initialValue,
                                fieldPath,
                                infoAdornment,
                                customFormSetter,
                                size,
                                removeHelperTextPadding, 
                                helperText,
                                width,
    required,
    options
                            }) => {
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState(false);

    const handleChange = (e) => {
        const { value: newValue } = e.target;
        const errorMessage = validator ? validator(newValue) : newValue === '' ? "Please select an option" : false;
        setValue(newValue);
        setError(errorMessage);
        onChange(!errorMessage);

        if (!customFormSetter) {
            setActiveForm((prevState) =>
                produce(prevState, (draft) => {
                    for (let i = 0; i < fieldPath.length - 1; i++) {
                        draft = draft[fieldPath[i]];
                    }

                    draft[fieldPath[fieldPath.length - 1]] = newValue;
                })
            );
        } else {
            customFormSetter(newValue, id);
        }
    };

    const getHelperText = (error, removeHelperTextPadding, helperText) => {
        if (error) {
            return error;
        }
        if (helperText) {
            return helperText;
        }
        if (removeHelperTextPadding) {
            return "";
        } else {
            return " ";
        }
    };

    return infoAdornment === null ? (
        <TextField
            key={id}
            id={id}
            label={label}
            error={!!error}
            helperText={getHelperText(error, removeHelperTextPadding, helperText)}
            value={value}
            select={!!options}
            size={!!size ? size : "medium"}
            onChange={handleChange}
            disabled={isSubmitting}
            required={required ?? false}
            sx={{ width: width ??  {xs: '200px !important', sm: '250px !important', md: '300px !important'} }}
        >
            {options && options.map((option, i) => (
                <MenuItem key={i} value={option} sx={{ textAlign: 'left' }}>
                    {option}
                </MenuItem>
            ))}
        </TextField>
    ) : (
        <TextField
            key={id}
            id={id}
            label={label}
            error={!!error}
            required={required ?? false}
            helperText={getHelperText(error, removeHelperTextPadding, helperText)}
            value={value}
            select={!!options}
            size={!!size ? size : "medium"}
            onChange={handleChange}
            disabled={isSubmitting}
            sx={{  width: width ??  {xs: '200px !important', sm: '250px !important', md: '300px !important'} }}
            slotProps={{
                input: { endAdornment: infoAdornment }
            }}
        >
            {options && options.map((option, i) => (
                <MenuItem key={i} value={option} sx={{ textAlign: 'left' }}>
                    {option}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default ValidatedTextField;